import { SvgIcon, type SvgIconProps } from "@mui/material";

export function Swap(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      sx={{
        ...props.sx,
      }}
    >
      <path d="M20 6L16 10V7H9C7.9 7 7 7.9 7 9C7 10.1 7.9 11 9 11H16C18.21 11 20 12.79 20 15C20 17.21 18.21 19 16 19H9V22L5 18L9 14V17H16C17.1 17 18 16.1 18 15C18 13.9 17.1 13 16 13H9C6.79 13 5 11.21 5 9C5 6.79 6.79 5 9 5H16V2L20 6Z" />
    </SvgIcon>
  );
}
